import { z } from 'zod'

export const commonGetMarqueeSchema = z.object({
  /** 訊息 */
  message: z.string(),
  /** 超連結 */
  hyperlink: z.string()
})

export interface CommonGetMarquee
  extends z.infer<typeof commonGetMarqueeSchema> {}

export class CommonGetMarquee {
  constructor() {
    return {
      message: '',
      hyperlink: ''
    }
  }
}
